import { useEffect, useState } from 'react';

import { useApolloClient } from 'application/providers/DataProvider';
import { toast } from '@shared/ui';
import { useAccountCompanyId } from 'application/hooks';

import { AcceptanceAdvanceStatus, BillingCompanyBillingInfoDocument } from '@shared/api/graphql/generated';
import { useAcceptanceAdvancedContext, SBBOL_MESSAGE } from '@entities/billing';

import { TEXTS } from './texts';

export const useSbbolIntegrationReturnListener = (): void => {
  const apolloClient = useApolloClient();
  const companyId = useAccountCompanyId();
  const { acceptanceAdvanced } = useAcceptanceAdvancedContext(companyId);

  const status = acceptanceAdvanced?.status || null;

  const [isReturnedFromIntegrationPage, setIsReturnedFromIntegrationPage] = useState<boolean>(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin || event.data.type !== SBBOL_MESSAGE) {
        return;
      }

      apolloClient.refetchQueries({ include: [BillingCompanyBillingInfoDocument] });
      setIsReturnedFromIntegrationPage(true);
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [apolloClient]);

  useEffect(() => {
    if (isReturnedFromIntegrationPage && status === AcceptanceAdvanceStatus.Pending) {
      toast.info(TEXTS.SBER_BUSINESS_ONLINE_ACCEPTANCE_ADVANCED_PENDING, { duration: 10000 });
    }
  }, [isReturnedFromIntegrationPage]);
};
